module.exports = __webpack_public_path__ + "img/loudou.9e2b826d.png";